<template>
    <div class="multiple-choice">
        <p class="copy questionText" v-html="$t(stepData.question)" tabindex="0"></p>

        <div class="multiple-choice-options">
            <div class="custom-radio-option" v-for="answer in stepData.answers" :key="answer.id">
                <input :name="answer.id" :id="'radio-' + _uid + '-' + answer.id" type="radio" class="radio-btn" :value="answer.id" v-model="clickedAnswers" @click="forceSingleSelection(answer.id, answer.point, $t(answer.label), answer.ans)">
                <label :for="'radio-' + _uid + '-' + answer.id">{{ $t(answer.label) }}</label>
            </div>
            <div class="btn-panel">
                <button v-if="stepData.step == 1" class="prev btn btn-white" v-on:click="previousChapter()">
                    <SvgIcon type="icon_arrow_left" class="arrowicon_prev chevron_prev"/>
                    <SvgIcon type="horizontal_line_red" class="arrowicon_prev line_red_prev"/>
                    {{ $t('general:prev') }}
                </button>
                <button v-else-if="stepData.step > 1" class="prev btn btn-white" v-on:click="previousQuestion()">
                    <SvgIcon type="icon_arrow_left" class="arrowicon_prev chevron_prev"/>
                    <SvgIcon type="horizontal_line_red" class="arrowicon_prev line_red_prev"/>
                    {{ $t('general:prev') }}
                </button>
                <button v-if="stepData.last && sectionTitle === 'sustainableProfitability'" class="next btn btn-red" v-bind:class="{ inactive: clickedAnswers.length === 0 }"  v-on:click="submit(true)" :tabindex="clickedAnswers.length === 0 ? -1 : 0">
                    {{ $t('general:ShowResults') }}
                    <SvgIcon type="horizontal_line_white" class="arrowicon line_white"/>
                    <SvgIcon type="icon_arrow_right" class="arrowicon chevron"/>
                </button>
                <button v-else class="next btn btn-red" v-bind:class="{ inactive: clickedAnswers.length === 0 }" v-on:click="submit(false)" :tabindex="clickedAnswers.length === 0 ? -1 : 0">
                    {{ $t('general:next') }}
                    <SvgIcon type="horizontal_line_white" class="arrowicon line_white"/>
                    <SvgIcon type="icon_arrow_right" class="arrowicon chevron"/>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import answerHandling from '@/mixins/answerHandling'
import current from '@/mixins/current'
import adobeTracking from '@/mixins/adobeTracking'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'MultipleChoice',
    props: [
        'stepData',
        'section',
        'last',
        'selectedAnswer',
        'multiple'
    ],
    mixins: [current, answerHandling, adobeTracking],
    components: {
        SvgIcon
    },
    data: function() {
        return {
            clickedAnswers: '',
            clickedAnswersPoints: 0,
            clickedAnswersValue: '',
            changeAnswers: true
        }
    },
    mounted() {
        this.selectedAnswers()
    },
    updated() {
        this.selectedAnswers()
    },
    computed: {
        questionTranslationVariable: function() {
            return (
                this.section +
                ':' +
                'step' +
                this.$store.getters['app/currentStep'] +
                '.question'
            )
        },
        chapterIntro: function() {
            return this.$store.getters['app/chapterIntro']
        },
        activeQuestionStep: function() {
            return this.$store.getters['app/activeQuestionStep']
        },
        sectionTitle: function() {
            return this.$store.getters['app/sectionTitle']
        },
        resultsOperational() {
            return this.$store.getters['answers/operational']
        },
        resultsStructural() {
            return this.$store.getters['answers/structural']
        },
        resultsEmotional() {
            return this.$store.getters['answers/emotional']
        },
        resultsSustainable() {
            return this.$store.getters['answers/sustainable']
        }
    },
    methods: {
        forceSingleSelection(answerId, point, value, ans) {
            this.changeAnswers = false
            this.clickedAnswers = answerId
            this.clickedAnswersPoints = point
            this.clickedAnswersValue = value
            this.answerSave(this.section, this.stepData.step, answerId, value, point, ans)
        },
        previousQuestion: function() {
            this.$parent.next(this.section, this.stepData.step, false, -1, 'prev')
        },
        previousChapter: function() {
            this.setChapterIntro(true)
            this.setActiveQuestionStep(0)
        },
        submit: function(lastQuestion) {
            this.changeAnswers = true
            this.clickedAnswers = ''
            this.$parent.next(this.section, this.stepData.step, this.stepData.last, +1, 'next')

            this.trackFormStep({
                name: 'section - ' + this.section,
                index: this.stepData.step,
                answer: 'Question' + this.stepData.step + '|' + this.clickedAnswersValue
            })
            if (lastQuestion) {
                this.$router.push({
                    name: 'result'
                })
            }
        },
        selectedAnswers: function() {
            if (this.changeAnswers) {
                if (this.section === 'operationalTransferability' && Object.keys(this.resultsOperational).length > 0 && this.resultsOperational[this.stepData.step]) {
                    this.clickedAnswers = this.resultsOperational[this.stepData.step].answerId
                    this.clickedAnswersPoints = this.resultsOperational[this.stepData.step].point
                    this.clickedAnswersValue = this.resultsOperational[this.stepData.step].answer
                } else if (this.section === 'structuralTransferability' && Object.keys(this.resultsStructural).length > 0 && this.resultsStructural[this.stepData.step]) {
                    this.clickedAnswers = this.resultsStructural[this.stepData.step].answerId
                    this.clickedAnswersPoints = this.resultsStructural[this.stepData.step].point
                    this.clickedAnswersValue = this.resultsStructural[this.stepData.step].answer
                } else if (this.section === 'emotionalTransferability' && Object.keys(this.resultsEmotional).length > 0 && this.resultsEmotional[this.stepData.step]) {
                    this.clickedAnswers = this.resultsEmotional[this.stepData.step].answerId
                    this.clickedAnswersPoints = this.resultsEmotional[this.stepData.step].point
                    this.clickedAnswersValue = this.resultsEmotional[this.stepData.step].answer
                } else if (this.section === 'sustainableProfitability' && Object.keys(this.resultsSustainable).length > 0 && this.resultsSustainable[this.stepData.step]) {
                    this.clickedAnswers = this.resultsSustainable[this.stepData.step].answerId
                    this.clickedAnswersPoints = this.resultsSustainable[this.stepData.step].point
                    this.clickedAnswersValue = this.resultsSustainable[this.stepData.step].answer
                }
            }
        }
    }
}
</script>
